import { z } from "zod";
import SafeRateLogo from "~/components/general/SafeRateLogo";

const ZInputServicingLockup = z.object({
	// Width of the whole lockup; the label is centred beneath the logo.
	className: z.string().optional(),
});

type TInputServicingLockup = z.infer<typeof ZInputServicingLockup>;

/**
 * The Safe Rate logo with "SERVICING" centred beneath it. Letter-spacing adds
 * a trailing gap after the last letter, which would pull centred text left,
 * so the same amount is added on the left to keep it exactly centred.
 */
const ServicingLockup = (_input: TInputServicingLockup) => {
	const input = ZInputServicingLockup.parse(_input);
	return (
		<span className={`flex flex-col items-center gap-1 ${input.className ?? "w-36"}`}>
			<SafeRateLogo className="h-auto w-full" title="Safe Rate Servicing" />
			<span
				aria-hidden="true"
				className="pl-[0.24em] font-semibold text-[10px] text-muted-foreground uppercase leading-none tracking-[0.24em]"
			>
				Servicing
			</span>
		</span>
	);
};

export default ServicingLockup;
